export default __webpack_public_path__ + "static/media/no-friendly-matches.fb66d781.png";